import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import { mapComponentThemes } from "../themes";
import { dropdownTheme } from "../Dropdown";
import { textInputTheme } from "../TextInput"; // $FlowFixMe - strict theme keys incompatible with mapComponentThemes

export var selectTheme = function selectTheme(baseTheme) {
  return mapComponentThemes({
    name: 'Dropdown',
    theme: dropdownTheme(baseTheme)
  }, {
    name: 'Select',
    theme: {}
  }, _objectSpread({}, selectTriggerTheme(baseTheme), baseTheme));
}; // $FlowFixMe - strict theme keys incompatible with mapComponentThemes

export var selectTriggerTheme = function selectTriggerTheme(baseTheme) {
  return mapComponentThemes({
    name: 'TextInput',
    theme: textInputTheme(baseTheme)
  }, {
    name: 'Select',
    theme: {
      Select_height_small: baseTheme.size_small,
      Select_height_medium: baseTheme.size_medium,
      Select_height_large: baseTheme.size_large,
      Select_height_jumbo: baseTheme.size_jumbo,
      SelectIcon_color: baseTheme.icon_color_theme
    }
  }, baseTheme);
};